import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ing_sc_virtual',
  templateUrl: './ing_sc_virtual.component.html',
  styleUrls: ['./ing_sc_virtual.component.css']
})
export class Ing_sc_virtualComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
